import { ReactNode } from 'react';
import { Context } from './installerContext.tsx';

export function PreviewProvider({ children }: { children: ReactNode }) {
	return (
		<Context.Provider value={{ installApp: () => {}, status: 'standby', progress: 0, isInstalled: false }}>{children}</Context.Provider>
	);
}
